import { cloneDeep, filter, reduce, isArray } from 'lodash';
import cart from '@/services/cart.service.ts';
import { ACCOUNT_CHECKOUT, LOCATION, STORAGE_KEYS } from '@/stores/defs';
import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
import cartService from '@/services/cart.service.ts';
var localforage = require('localforage');
var cartKeyName = STORAGE_KEYS.cartKeyName;
var state = {
    items: [],
    status: null,
    currentItem: {},
    totals: {
        collected: 0,
        discount: 0,
        gratuity: 0,
        refund: 0,
        serviceCharge: 0,
        subTotal: 0,
        tax: 0,
    },
    coupon: null,
    applyOffer: null,
    transactionId: '',
};
var getters = {
    items: function (state) {
        return state.items;
    },
    lineItemCount: function (state) {
        if (!state.items) {
            return 0;
        }
        var count = state.items.length;
        return count;
    },
    itemCount: function (state) {
        var count = reduce(state.items, function (acc, item) {
            return acc + +item.quantity;
        }, 0);
        return count;
    },
    itemPrice: function (state) { return function (index) {
        var item = state.items[index];
        var price = cart.getItemPrice(item);
        return price;
    }; },
    nonBundleItems: function (state) {
        var filteredItems = filter(state.items, function (item) {
            return !item.bundle;
        });
        return filteredItems;
    },
    // TODO will have to use CartItemInterface 
    // in other functions
    couponItems: function (state) {
        var couponItems = filter(state.items, function (item) {
            return item.hasCoupon();
        });
        return couponItems;
    },
    currentItem: function (state) {
        return state.currentItem;
    },
    price: function (state) {
        if (state.items.length === 0) {
            return 0;
        }
        var total = cart.getCartTotal(state.items);
        return total;
    },
    itemQuantity: function (state) {
        return state.currentItem.quantity || 0;
    },
    checkoutTotal: function (state, getters, rootState, rootGetters) {
        var itemTotal = cartService.calculateOrderTotal(state.totals);
        // TODO: get delivery fee server side
        if (rootGetters[ACCOUNT_CHECKOUT.GET_SERVICE_TYPE] === EServiceType.SERVICE_TYPE_DELIVERY && rootGetters[LOCATION.GET_LOCATION].id) {
            return itemTotal + parseInt(rootGetters[LOCATION.GET_LOCATION].delivery.baseDeliveryFee);
        }
        else {
            return itemTotal;
        }
    },
    getTotals: function (state) {
        return state.totals;
    },
    getCoupon: function (state) {
        return state.coupon;
    },
    getApplyOffer: function (state) {
        return state.applyOffer;
    },
    getTransactionId: function (state) {
        return state.transactionId;
    }
};
var actions = {
    addItem: function (_a, _item) {
        var state = _a.state, commit = _a.commit;
        var cartItem = (_item) ? cart.prepareItem(_item) : state.currentItem;
        commit('pushItemToCart', cartItem);
    },
    setCurrentItem: function (_a, item) {
        var commit = _a.commit;
        var cartItem = cart.prepareItem(item);
        commit('setCurrentItem', cartItem);
    },
    incrementQuantity: function (_a) {
        var state = _a.state, commit = _a.commit;
        var maxQuantity = cart.getItemMax(state.currentItem);
        var quantity = state.currentItem.quantity;
        if (quantity < maxQuantity) {
            quantity++;
        }
        commit('changeCurrentQuantity', quantity);
    },
    decrementQuantity: function (_a) {
        var state = _a.state, commit = _a.commit;
        var quantity = state.currentItem.quantity;
        if (quantity > 1) {
            quantity--;
        }
        commit('changeCurrentQuantity', quantity);
    },
    incrementItemQuantity: function (_a, _item) {
        var state = _a.state, commit = _a.commit;
        var itemIndex = cart.getItemIndex(state.items, _item);
        var item = state.items[itemIndex];
        var maxQuantity = cart.getItemMax(item);
        var quantity = item.quantity;
        if (quantity < maxQuantity) {
            quantity++;
        }
        commit('changeItemQuantity', {
            amount: quantity,
            index: itemIndex,
        });
    },
    decrementItemQuantity: function (_a, _item) {
        var state = _a.state, commit = _a.commit;
        var itemIndex = cart.getItemIndex(state.items, _item);
        var item = state.items[itemIndex];
        var quantity = item.quantity;
        if (quantity > 0) {
            quantity--;
            commit('changeItemQuantity', {
                amount: quantity,
                index: itemIndex,
            });
        }
        else {
            commit('removeItem', itemIndex);
        }
    },
    setItemQuantity: function (_a, _b) {
        var commit = _a.commit;
        var _item = _b._item, quantity = _b.quantity;
        var itemIndex = cart.getItemIndex(state.items, _item);
        commit('changeItemQuantity', {
            amount: quantity,
            index: itemIndex,
        });
    },
    setCurrentItemQuantity: function (_a, quantity) {
        var commit = _a.commit;
        commit('changeCurrentQuantity', quantity);
    },
    removeItem: function (_a, _item) {
        var state = _a.state, commit = _a.commit;
        var itemIndex = cart.getItemIndex(state.items, _item);
        commit('removeItem', itemIndex);
    },
    updateItem: function (_a, _b) {
        var commit = _a.commit;
        var _item = _b._item, index = _b.index;
        var item = _item;
        if (!item) {
            return;
        }
        if (item.__mc === 'ItemModel') {
            item = cart.prepareItem(_item);
        }
        commit('updateItem', {
            item: item,
            index: index,
        });
    },
    setCart: function (_a, items) {
        var state = _a.state, commit = _a.commit;
        commit('setCart', items);
    },
    clearCart: function (_a) {
        var state = _a.state, commit = _a.commit;
        commit('clearCart');
    },
    setTotals: function (_a, totals) {
        var state = _a.state, commit = _a.commit;
        commit("setTotals", totals);
    },
    setTip: function (_a, tip) {
        var commit = _a.commit;
        commit('setTip', tip);
    },
    setCoupon: function (_a, coupon) {
        var commit = _a.commit;
        commit('setCoupon', coupon);
    },
    setApplyOffer: function (_a, itemId) {
        var commit = _a.commit;
        commit('setApplyOffer', itemId);
    },
    setTransactionId: function (_a, transactionId) {
        var commit = _a.commit;
        commit('setTransactionId', transactionId);
    }
};
var mutations = {
    pushItemToCart: function (state, item) {
        var clone = cloneDeep(item);
        if (typeof state.items === 'undefined' || !isArray(state.items)) {
            state.items = [];
        }
        state.items.push(clone);
        state.currentItem.quantity = 1; // reset quantity
        state.currentItem.options = [];
        localforage.setItem(cartKeyName, state.items);
    },
    changeItemQuantity: function (state, _a) {
        var amount = _a.amount, index = _a.index;
        state.items[index].quantity = amount;
        localforage.setItem(cartKeyName, state.items);
    },
    changeCurrentQuantity: function (state, amount) {
        state.currentItem.quantity = amount;
        if (typeof state.currentItem.invalidatePriceCache === 'function') {
            state.currentItem.invalidatePriceCache();
        }
    },
    setCurrentItem: function (state, item) {
        state.currentItem = item;
    },
    removeItem: function (state, itemIndex) {
        state.items.splice(itemIndex, 1);
        var removedItemState = state.items;
        localforage.setItem(cartKeyName, state.items).then(function () {
            state.items = removedItemState;
        });
    },
    updateItem: function (state, _a) {
        var item = _a.item, index = _a.index;
        state.items[index] = item;
        localforage.setItem(cartKeyName, state.items);
    },
    setCart: function (state, items) {
        state.items = items;
        localforage.setItem(cartKeyName, state.items);
    },
    clearCart: function () {
        state.items = [];
        state.status = null;
        state.currentItem = {};
        localforage.setItem(cartKeyName, []);
    },
    setTotals: function (state, totals) {
        state.totals = totals;
    },
    setTip: function (state, tip) {
        state.totals.gratuity = tip;
    },
    setCoupon: function (state, coupon) {
        state.coupon = coupon;
    },
    setApplyOffer: function (state, itemId) {
        state.applyOffer = itemId;
    },
    setTransactionId: function (state, transactionId) {
        state.transactionId = transactionId;
    }
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/cart.store.ts
// module id = null
// module chunks = 